export const headers = { 'Authorization': `Bearer ${process.env.REACT_APP_strapiToken}` };
export const cmsHeaders = { 'Authorization': `Bearer ${process.env.REACT_APP_cmsToken}` };